import { Col, Form, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import { removeItemArrayObject } from '../../../../../helpers/array';
import { searchEspeciesByProduto } from '../../../../../helpers/especies';
import { filterAllOption, filterOption } from '../../../../../helpers/form';
import {
  formatarCnpjCpfIMask,
  limitarLabel,
} from '../../../../../helpers/formatador';
import { geraKey } from '../../../../../helpers/geradores';
import { getPagadores } from '../../../../../helpers/pagadores';
import { searchProdutosByClientePagador } from '../../../../../helpers/produtos';
import { useAuth } from '../../../../../security/authContext';
import apiShipper from '../../../../../services/apiShipper';
import FormSelectClienteOrigemDestino from '../../components/FormSelectClienteOrigemDestino';
import { Card, ColCard, Title } from '../../styles';
import { GlobalStyle } from './styles';

export default function StepDadosGerais({
  setDadosPagador,
  form,
  clienteEnderecoRemetente,
  setClienteEnderecoRemetente,
  clienteEnderecoDestinatario,
  setClienteEnderecoDestinatario,
  dadosPagador,
  demanda,
  setDemanda,
  hasContrato,
  hasMotorista,
  setAlertMessageErrors,
  clienteExpedidor,
}) {
  const { user } = useAuth();
  const [apiProdutos, setProdutos] = useState([]);
  const [apiClientes, setApiClientes] = useState([]);
  const [apiEspecies, setApiEspecies] = useState([]);
  const [loadingEspecies, setLoadingEspecies] = useState(false);
  const [loadingProdutos, setLoadingProdutos] = useState(false);
  const [disabledFields, setDisabledFields] = useState(false);
  const [disabledEspecie, setDisabledEspecie] = useState(false);
  const NAME_ERROR = 'tarifa-cliente-error';
  const { removeContatoAction, addContatoAction } = useContatosContext();

  const handleBuscarTarifaCliente = async clienteId => {
    try {
      setAlertMessageErrors(state => [
        ...removeItemArrayObject(state, 'key', NAME_ERROR),
      ]);
      await apiShipper.get('/tarifa-cliente-tmov', {
        params: {
          idCliente: clienteId,
        },
      });
    } catch (err) {
      setAlertMessageErrors(state => [
        ...state,
        {
          key: NAME_ERROR,
          message:
            'As tarifas não foram parametrizadas. Contate a nossa equipe comercial para mais informações',
          fixed: true,
        },
      ]);
    }
  };

  const handleSelectPagador = async id => {
    const idTratado = id.split(':')[0];

    if (dadosPagador.id) {
      dadosPagador.clienteEmails.forEach(email => {
        removeContatoAction(email);
      });
    }

    const pagador = apiClientes.find(
      apiCliente => apiCliente.id === Number(idTratado)
    );

    form.setFieldsValue({
      produto: null,
      especie: null,
    });

    demanda.idClientePagador = pagador.id;
    demanda.idClienteShipper = pagador.id_cliente_raiz;
    demanda.razao_social = pagador.razao_social;
    demanda.cnpj = pagador.cnpj;
    demanda.idProduto = null;
    setDemanda(demanda);
    setDadosPagador(pagador);
    setDisabledFields(false);
    setDisabledEspecie(false);

    if (pagador && pagador.clienteEmails) {
      pagador.clienteEmails.forEach(email => {
        if (email) {
          addContatoAction(email);
        }
      });
    }

    handleBuscarTarifaCliente(pagador.id_cliente_raiz);
  };

  const handleSetProdutoDescricao = async (idProduto, descricaoProduto) => {
    if (!idProduto) return;

    await searchEspeciesByProduto(
      demanda.idClientePagador,
      idProduto,
      setApiEspecies,
      setLoadingEspecies
    );

    demanda.descricaoProduto = descricaoProduto;
    setDemanda(demanda);

    form.setFieldsValue({
      produto: idProduto,
    });
  };

  useEffect(() => {
    async function onInit() {
      const pagadores = await getPagadores(user);
      if (pagadores) setApiClientes(pagadores);
    }

    onInit();
  }, [user]);

  useEffect(() => {
    async function getProdutos() {
      if (!demanda.idClientePagador) return;
      const { idProduto, produtoNome } = demanda;
      await searchProdutosByClientePagador(
        demanda.idClientePagador,
        setProdutos,
        setLoadingProdutos
      );
      await handleSetProdutoDescricao(idProduto, produtoNome);

      if (apiClientes.length > 0) {
        const pagador = apiClientes.find(
          apiCliente => apiCliente.id === demanda.idClientePagador
        );

        demanda.idClientePagador = pagador.id;
        demanda.idClienteShipper = pagador.id_cliente_raiz;
        demanda.razao_social = pagador.razao_social;
        demanda.cnpj = pagador.cnpj;
        setDemanda(demanda);
        setDadosPagador(pagador);
      }

      if (hasContrato || hasMotorista) {
        setDisabledFields(true);
        setDisabledEspecie(true);
      }
    }

    getProdutos();
  }, [demanda?.idClientePagador, apiClientes]);

  useEffect(() => {
    setDisabledEspecie(false);
    if (apiEspecies.length === 1) {
      form.setFieldsValue({
        especie: apiEspecies[0].IdEspecie,
      });
      setDisabledEspecie(true);
    }
  }, [apiEspecies]);

  return (
    <>
      <GlobalStyle />

      <Row style={{ height: '90%' }}>
        <ColCard span={12} className="height-71">
          <Card className="height-71">
            <Title>Dados Gerais</Title>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="cnpjPagador"
                  label="Cliente Pagador"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor, selecione um CNPJ!',
                    },
                  ]}
                >
                  <Select
                    aria-label="cnpjPagador"
                    showSearch
                    disabled={disabledFields}
                    showArrow={false}
                    placeholder="Selecione um CPNJ"
                    showAction={['click']}
                    onChange={handleSelectPagador}
                    filterOption={(input, { title: titleOption }) =>
                      filterAllOption(input, titleOption)
                    }
                  >
                    {apiClientes.map((dado, index) => {
                      const getBairro = () =>
                        dado.id_cliente_endereco
                          ? `- (${dado.bairro_cliente_endereco})`
                          : null;
                      return (
                        <Select.Option
                          key={geraKey(dado.id)}
                          value={`${dado.id}:${index}`}
                          title={`${dado.razao_social} - ${formatarCnpjCpfIMask(
                            dado.cnpj
                          )} - ${dado.cidade} - ${dado.uf} ${getBairro()}`}
                        >
                          {limitarLabel(dado.razao_social, 20)}
                          &nbsp; - &nbsp;
                          {formatarCnpjCpfIMask(dado.cnpj)}
                          &nbsp; - &nbsp;
                          {dado.cidade.toUpperCase()}
                          &nbsp; ({dado.uf}
                          )&nbsp;
                          {getBairro()}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item
                  name="produto"
                  label="Produtos"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor, insira um produto!',
                    },
                  ]}
                >
                  <Select
                    aria-label="produto"
                    showSearch
                    disabled={disabledFields}
                    showArrow={false}
                    placeholder="Ex: SOJA"
                    filterOption={(input, { children }) =>
                      filterOption(input, children, 1)
                    }
                    showAction={['click']}
                    onChange={(value, { title }) =>
                      handleSetProdutoDescricao(value, title)
                    }
                    loading={loadingProdutos}
                  >
                    {apiProdutos.map(dado => (
                      <Select.Option
                        key={dado.IdProduto}
                        value={dado.IdProduto}
                        title={dado.Descricao}
                      >
                        {`${dado.IdProduto} - ${dado.Descricao}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12} offset={1}>
                <Form.Item
                  name="especie"
                  label="Espécie"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor, insira uma espécie!',
                    },
                  ]}
                >
                  <Select
                    aria-label="especie"
                    showSearch
                    disabled={disabledFields || disabledEspecie}
                    showArrow={false}
                    placeholder="Ex: BALDE"
                    filterOption={(input, { title: titleOption }) =>
                      filterOption(input, titleOption, 0)
                    }
                    showAction={['click']}
                    loading={loadingEspecies}
                  >
                    {apiEspecies.map(dado => (
                      <Select.Option
                        key={dado.IdEspecie}
                        title={dado.Descricao}
                        value={dado.IdEspecie}
                      >
                        {dado.Descricao}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item name="numPedidoCliente" label="Número do pedido">
                  <Input className="total-width" />
                </Form.Item>
              </Col>
            </Row>

            <FormSelectClienteOrigemDestino
              label="Remetente"
              clienteOrigemDestino={clienteEnderecoRemetente}
              setClienteOrigemDestino={setClienteEnderecoRemetente}
              disabled={disabledFields}
              setAlertMessageErrors={setAlertMessageErrors}
              dadosPagador={dadosPagador}
              tipo="Remetente"
              clienteExpedidor={clienteExpedidor}
            />

            <FormSelectClienteOrigemDestino
              label="Destinatário"
              clienteOrigemDestino={clienteEnderecoDestinatario}
              setClienteOrigemDestino={setClienteEnderecoDestinatario}
              disabled={disabledFields}
              setAlertMessageErrors={setAlertMessageErrors}
              dadosPagador={dadosPagador}
              tipo="Destinatario"
            />
          </Card>
        </ColCard>

        <ColCard span={12}>
          <Card>
            <Title>Informações adicionais</Title>
            <Row>
              <Col span={24}>
                <Form.Item name="observacoes" label="Observações">
                  <Input.TextArea
                    placeholder="Escreva aqui informações que deverão ser direcionadas ao motorista. Ex: Roteiro, uso de EPIs"
                    className="total-width resize-textarea-none"
                    maxLength={500}
                    showCount
                    rows={4}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepDadosGerais.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
  clienteEnderecoRemetente: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteEnderecoRemetente: PropTypes.func.isRequired,
  clienteEnderecoDestinatario: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteEnderecoDestinatario: PropTypes.func.isRequired,
  demanda: PropTypes.objectOf(PropTypes.any).isRequired,
  setDemanda: PropTypes.func.isRequired,
  dadosPagador: PropTypes.shape({
    id: PropTypes.number,
    cnpj: PropTypes.string,
    clienteEmails: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
  setDadosPagador: PropTypes.func.isRequired,
  hasContrato: PropTypes.bool,
  hasMotorista: PropTypes.bool,
  setAlertMessageErrors: PropTypes.func.isRequired,
  clienteExpedidor: PropTypes.arrayOf(PropTypes.any),
};

StepDadosGerais.defaultProps = {
  hasContrato: false,
  hasMotorista: false,
  clienteExpedidor: [],
};
